import React from 'react';
import { Device } from '../../lib/types';
import { useToast } from '../../components/Toast/ToastContext';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

interface ResendEmailModalProps {
  open: boolean;
  onClose: () => void;
  device: Device | null;
  onResend: (deviceId: string) => void;
}

export default function ResendEmailModal({ open, onClose, device, onResend }: ResendEmailModalProps) {
  const { showToast } = useToast();

  if (!device) {
    return null;
  }

  const currentDevice = device;

  function handleConfirm() {
    onResend(currentDevice.id);
    showToast(`Setup email resent to ${currentDevice.adopterEmail}`);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Resend setup email</ModalTitle>
      <ModalSubtitle>
        Resend the setup email to {device.adopterName} at {device.adopterEmail}?
      </ModalSubtitle>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Resend Email
        </Button>
      </ModalActions>
    </Modal>
  );
}
